import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { PositionHint as t, indexOf as h, removeUnordered as i, removeUnorderedMany as s } from "./arrayUtils.js";
import a from "./HeapSort.js";
var e = 1.5,
    l = 1.1;

var n = /*#__PURE__*/function () {
  function n(h) {
    var _this = this;

    _classCallCheck(this, n);

    this.data = [], this._length = 0, this._allocator = void 0, this._deallocator = function () {
      return null;
    }, this._shrink = function () {}, this._hint = new t(), h && (h.initialSize && (this.data = new Array(h.initialSize)), h.allocator && (this._allocator = h.allocator), void 0 !== h.deallocator && (this._deallocator = h.deallocator), h.shrink && (this._shrink = function () {
      return r(_this);
    }));
  }

  _createClass(n, [{
    key: "toArray",
    value: function toArray() {
      return this.data.slice(0, this.length);
    }
  }, {
    key: "getItemAt",
    value: function getItemAt(t) {
      if (!(t < 0 || t >= this._length)) return this.data[t];
    }
  }, {
    key: "length",
    get: function get() {
      return this._length;
    },
    set: function set(t) {
      if (t > this._length) {
        if (this._allocator) {
          for (; this._length < t;) {
            this.data[this._length++] = this._allocator(this.data[this._length]);
          }

          return;
        }

        this._length = t;
      } else {
        if (this._deallocator) for (var _h = t; _h < this._length; ++_h) {
          this.data[_h] = this._deallocator(this.data[_h]);
        }
        this._length = t, this._shrink();
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      this.length = 0;
    }
  }, {
    key: "prune",
    value: function prune() {
      this.clear(), this.data = [];
    }
  }, {
    key: "push",
    value: function push(t) {
      this.data[this._length++] = t;
    }
  }, {
    key: "pushArray",
    value: function pushArray(t) {
      var h = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t.length;

      for (var _i = 0; _i < h; _i++) {
        this.data[this._length++] = t[_i];
      }
    }
  }, {
    key: "fill",
    value: function fill(t, h) {
      for (var _i2 = 0; _i2 < h; _i2++) {
        this.data[this._length++] = t;
      }
    }
  }, {
    key: "pushNew",
    value: function pushNew() {
      this._allocator && (this.data[this.length] = this._allocator(this.data[this.length]));
      var t = this.data[this._length];
      return ++this._length, t;
    }
  }, {
    key: "unshift",
    value: function unshift(t) {
      this.data.unshift(t), this._length++, r(this);
    }
  }, {
    key: "pop",
    value: function pop() {
      if (0 === this.length) return;
      var t = this.data[this.length - 1];
      return this.length = this.length - 1, this._shrink(), t;
    }
  }, {
    key: "remove",
    value: function remove(t) {
      var i = h(this.data, t, this.length, this._hint);
      if (-1 !== i) return this.data.splice(i, 1), this.length = this.length - 1, t;
    }
  }, {
    key: "removeUnordered",
    value: function removeUnordered(t) {
      var h = i(this.data, t, this.length, this._hint);
      return void 0 !== h && (this.length = this.length - 1), this._shrink(), h;
    }
  }, {
    key: "removeUnorderedIndex",
    value: function removeUnorderedIndex(t) {
      if (!(t >= this.length || t < 0)) return this.swapElements(t, this.length - 1), this.pop();
    }
  }, {
    key: "removeUnorderedMany",
    value: function removeUnorderedMany(t) {
      var h = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : t.length;
      var i = arguments.length > 2 ? arguments[2] : undefined;
      this.length = s(this.data, t, this.length, h, this._hint, i), this._shrink();
    }
  }, {
    key: "front",
    value: function front() {
      if (0 !== this.length) return this.data[0];
    }
  }, {
    key: "back",
    value: function back() {
      if (0 !== this.length) return this.data[this.length - 1];
    }
  }, {
    key: "swapElements",
    value: function swapElements(t, h) {
      var _ref;

      t >= this.length || h >= this.length || t === h || (_ref = [this.data[h], this.data[t]], this.data[t] = _ref[0], this.data[h] = _ref[1], _ref);
    }
  }, {
    key: "sort",
    value: function sort(t) {
      a.sort(this.data, 0, this.length, t);
    }
  }, {
    key: "iterableSort",
    value: function iterableSort(t) {
      return a.iterableSort(this.data, 0, this.length, t);
    }
  }, {
    key: "some",
    value: function some(t, h) {
      for (var _i3 = 0; _i3 < this.length; ++_i3) {
        if (t.call(h, this.data[_i3], _i3, this.data)) return !0;
      }

      return !1;
    }
  }, {
    key: "filterInPlace",
    value: function filterInPlace(t, h) {
      var i = 0;

      for (var _s = 0; _s < this._length; ++_s) {
        var _a = this.data[_s];
        t.call(h, _a, _s, this.data) && (this.data[_s] = this.data[i], this.data[i] = _a, i++);
      }

      if (this._deallocator) for (var _s2 = i; _s2 < this._length; _s2++) {
        this.data[_s2] = this._deallocator(this.data[_s2]);
      }
      return this._length = i, this._shrink(), this;
    }
  }, {
    key: "forAll",
    value: function forAll(t, h) {
      var i = this.length,
          s = this.data;

      for (var _a2 = 0; _a2 < i; ++_a2) {
        t.call(h, s[_a2], _a2, s);
      }
    }
  }, {
    key: "forEach",
    value: function forEach(t, h) {
      for (var _i4 = 0; _i4 < this.length; ++_i4) {
        t.call(h, this.data[_i4], _i4, this.data);
      }
    }
  }, {
    key: "map",
    value: function map(t, h) {
      var i = new Array(this.length);

      for (var _s3 = 0; _s3 < this.length; ++_s3) {
        i[_s3] = t.call(h, this.data[_s3], _s3, this.data);
      }

      return i;
    }
  }, {
    key: "reduce",
    value: function reduce(t, h) {
      var i = h;

      for (var _s4 = 0; _s4 < this.length; ++_s4) {
        i = t(i, this.data[_s4], _s4, this.data);
      }

      return i;
    }
  }, {
    key: "has",
    value: function has(t) {
      var h = this.length,
          i = this.data;

      for (var _s5 = 0; _s5 < h; ++_s5) {
        if (i[_s5] === t) return !0;
      }

      return !1;
    }
  }]);

  return n;
}();

function r(t) {
  t.data.length > e * t.length && (t.data.length = Math.floor(t.length * l));
}

export { n as default };